export default "__VITE_PUBLIC_ASSET__4e321ed8__"